export default __webpack_public_path__ + "static/media/Hair_12_M_C1.0882d8d3.svg";